export { default } from './PromotionTeaser';
